import { Outlet, useParams } from "react-router-dom";
import React, { useEffect } from "react";

import { connect } from "react-redux";
import { updateRestaurantData } from "../redux/actions/userDataActions";
import Loader from "./Loader";
import { useGetRestaurantData } from "../api/useQueryHooks";

const RestIdLayout = (props) => {
  const { rest_id } = useParams();

  const { data: restaurantData, isLoading, isError } = useGetRestaurantData(rest_id);

  useEffect(() => {
    if (restaurantData) {
      props.updateRestaurantData(restaurantData);
      document.title = `Foodo - ${restaurantData.name}`;
    } else if (!rest_id) {
      document.title = `Foodo - Admin`;
    }
  }, [restaurantData]);

  // Block child routes until data is available so pages never mount with a
  // mismatched or empty Restaurant-ID. On error we let through so nothing
  // is permanently stuck.
  if (rest_id && isLoading && !isError) {
    return <Loader height={{ height: "100vh" }} />;
  }

  return <Outlet />;
};

const mapStateToProps = (state) => ({
  restaurantData: state.userData.restaurantData,
});

const mapDispatchToProps = (dispatch) => ({
  updateRestaurantData: (data) => dispatch(updateRestaurantData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RestIdLayout);
